import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

class MessageVariantsClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}) {
    return appApiUrl(`messages/variants/`, {projectId, workspaceId});
  }

  processResponse(response) {
    return response.results;
  }
}

export const messageVariantsClient = new MessageVariantsClient();
